export default __webpack_public_path__ + "static/media/bilyana_l.b8b8ac60.jpg";